/*Состояния*/
const state = () => ({
  resultTemplateName: null,
  searchData: null,
  entityName: null,
  entityId: null,
});
export { state };
